import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig, MatDialogModule} from '@angular/material/dialog';
import {MatDynamicControlsComponent, MatDynamicFormModule} from '@im-ng/form/mat';
import { TextActPipe } from '@im-ng/text/act';
import {DotNl2brPipe, DotNonKrPipe} from '@ng-dot/core';
import {DotInputControlModule} from '@ng-dot/form/input-control';
import {DotLinkModule} from '@ng-dot/ui/link';
import {DotPoseModule} from '@ng-dot/ui/pose';
import {DotZoneDirective} from '@ng-dot/ux/zone';
import {ConfirmDialogComponent} from './confirm-dialog.component';
import {DialogAreaComponent} from './dialog-area.component';
import {DialogSectionComponent} from './dialog-section.component';
import {FormDialogComponent} from './form-dialog.component';
import {DotIconModule} from '@ng-dot/ui/icon';

export type DialogConfig = {
	[K in keyof MatDialogConfig]?: MatDialogConfig[K];
};

@NgModule({
	declarations: [
		DialogAreaComponent,
		DialogSectionComponent,
		ConfirmDialogComponent,
		FormDialogComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		DotInputControlModule,
		DotLinkModule,
		DotNl2brPipe,
		DotNonKrPipe,
		DotPoseModule,
		DotZoneDirective,
		MatDialogModule,
		MatDynamicControlsComponent,
		MatDynamicFormModule,
		TextActPipe,
		DotIconModule
	],
	exports: [
		DialogAreaComponent,
		DialogSectionComponent,
		ConfirmDialogComponent,
		FormDialogComponent
	]
})
/**
 * 대화상자 모듈
 */
export class DialogModule {
	/**
	 * 대화상자 모듈 활성
	 * :`AppModule` 에서 수입
	 * @param data MatDialogModule 의 설정을 그대로 사용
	 */
	static forRoot(data: DialogConfig = {}): ModuleWithProviders<DialogModule> {
		return {
			ngModule: DialogModule,
			providers: [
				{
					provide: MAT_DIALOG_DEFAULT_OPTIONS,
					useValue: {
						autoFocus: false,
						hasBackdrop: true,
						...data
					}
				}
			]
		};
	}
}
